import React from 'react';
import { motion } from 'framer-motion';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useTranslation } from '../hooks/useTranslation';

export default function DatenschutzPageRU() {
  const { currentLanguage } = useTranslation();
  
  // Отладочная информация
  console.log('DatenschutzPageRU - currentLanguage:', currentLanguage);
  
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
  };

  return (
    <div className="min-h-screen bg-white text-dark-900">
      <Header />
      <main className="pt-16 sm:pt-20">
        <motion.section
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="py-8 sm:py-16 lg:py-20"
        >
          <div className="max-w-4xl mx-auto px-3 sm:px-4 lg:px-8">
            <motion.div variants={item} className="text-center mb-8 sm:mb-12">
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6 text-dark-900">
                Политика конфиденциальности
              </h1>
              <p className="text-sm sm:text-base text-gray-600">
                Дата: 20 сентября 2025
              </p>
            </motion.div>

            <motion.div variants={item} className="prose prose-sm sm:prose-lg max-w-none">
              <div className="bg-gray-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">1. Общая информация о защите данных</h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Владелец этого сайта серьёзно относится к защите ваших персональных данных. Я обрабатываю ваши персональные данные конфиденциально, в строгом соответствии с действующими положениями о защите данных и этой Политикой конфиденциальности.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Анализ вашего поведения на сайте обычно проводится анонимно: его нельзя отследить до вас лично. Вы можете отказаться от этого анализа или предотвратить его, отключив определённые инструменты.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">2. Общие положения и обязательная информация</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Защита данных</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Владелец этого сайта серьёзно относится к защите ваших персональных данных. Я обрабатываю ваши данные конфиденциально, в строгом соответствии с действующими нормами законодательства о защите данных и нашей Политикой конфиденциальности.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  При использовании нашего веб-сайта мы собираем различные персональные данные. Персональные данные — это информация, с помощью которой можно идентифицировать вас лично. Эта Политика конфиденциальности объясняет, какие данные мы собираем и с какой целью их используем.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4 sm:mb-6">
                  Обратите внимание: передача данных через Интернет (например, при общении по электронной почте) может иметь уязвимости в безопасности. Полная защита данных от доступа третьих лиц невозможна.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Ответственное лицо</h3>
                <div className="bg-gray-50 rounded-lg sm:rounded-xl p-3 sm:p-4 mb-4 sm:mb-6">
                  <p className="text-sm sm:text-base text-gray-700 font-medium mb-2">За обработку данных на этом веб-сайте отвечает:</p>
                  <div className="text-sm sm:text-base text-gray-700">
                    <p><strong>Alfira Herrmann</strong></p>
                    <p>Hochburgerstr. 32</p>
                    <p>79312 Emmendingen</p>
                    <p>Тел: +49 (0) 7641 95 37 645</p>
                    <p>E-Mail: alphavita@gmx.de</p>
                  </div>
                </div>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Хостинг</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Наш веб-сайт размещается у профессионального хостинг-провайдера. Данные хранятся на защищённых серверах и соответствуют высочайшим стандартам безопасности.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Отзыв согласия на обработку данных</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Большинство операций по обработке данных возможны только с вашего явного согласия. Вы имеете право в любой момент отозвать данное ранее согласие. Для этого достаточно отправить нам неофициальное уведомление по электронной почте.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">SSL/TLS-шифрование</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Этот сайт использует SSL/TLS-шифрование в целях безопасности и для защиты передачи конфиденциальных данных. Зашифрованное соединение можно узнать по изменению адреса сайта с "http://" на "https://" в адресной строке браузера.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Право на информацию, блокировку, удаление</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  В соответствии с действующим законодательством вы имеете право в любое время бесплатно получить информацию о ваших сохранённых персональных данных, об их источнике и получателях, а также о целях их обработки. При необходимости вы также имеете право на исправление, блокировку или удаление этих данных.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">3. Сбор данных на нашем веб-сайте</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Файлы cookie</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Наш веб-сайт частично использует так называемые файлы cookie. Файлы cookie не наносят вреда вашему компьютеру и не содержат вирусов. Они служат для того, чтобы сделать наш сайт более удобным, эффективным и безопасным для пользователей.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Большинство используемых нами cookie-файлов — это так называемые "сеансовые cookie". Они автоматически удаляются после вашего ухода с сайта.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Серверные файлы журнала (Server-Log-Files)</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Провайдер сайта автоматически собирает и сохраняет информацию в так называемых серверных файлах журнала, которые ваш браузер автоматически передаёт нам. К ним относятся:
                </p>
                <ul className="list-disc list-inside text-sm sm:text-base text-gray-700 mb-3 sm:mb-4 space-y-1">
                  <li>Тип и версия браузера</li>
                  <li>Используемая операционная система</li>
                  <li>URL источника</li>
                  <li>Имя хоста компьютера, с которого отправлен запрос</li>
                  <li>Время запроса к серверу</li>
                  <li>IP-адрес</li>
                </ul>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Контактная форма</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Когда вы отправляете нам запросы через контактную форму, предоставленные вами данные, включая контактную информацию, сохраняются у нас для обработки вашего запроса и для ответа на последующие вопросы. Мы не передаём эти данные третьим лицам без вашего согласия.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">4. Социальные сети и внешние ссылки</h2>
                
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Наш сайт использует плагины и кнопки, которые позволяют делиться контентом в социальных сетях, таких как WhatsApp, Facebook, LinkedIn, Instagram и других.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Обратите внимание: как только вы переходите по ссылке на сторонний ресурс, сбор и обработка ваших данных начинают регулироваться политикой конфиденциальности соответствующей социальной сети. Мы не несём ответственности за сбор и использование ваших данных на этих платформах.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Чтобы получить информацию о том, как эти сайты обрабатывают ваши данные, ознакомьтесь с их политикой конфиденциальности:
                </p>
                <ul className="list-disc list-inside text-sm sm:text-base text-gray-700 space-y-1">
                  <li><a href="https://www.whatsapp.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">WhatsApp: Политика конфиденциальности WhatsApp</a></li>
                  <li><a href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">Facebook: Политика конфиденциальности Facebook</a></li>
                  <li><a href="https://www.linkedin.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">LinkedIn: Политика конфиденциальности LinkedIn</a></li>
                  <li><a href="https://privacycenter.instagram.com/policy/?entry_point=ig_help_center_data_policy_redirect" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">Instagram: Политика конфиденциальности Instagram</a></li>
                </ul>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">5. Инструменты аналитики и реклама</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Google Analytics</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Наш сайт использует функции сервиса веб-аналитики Google Analytics. Google Analytics применяет так называемые файлы cookie. Эти текстовые файлы сохраняются на вашем компьютере и позволяют анализировать использование сайта.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Мы активировали функцию анонимизации IP на этом сайте. Это означает, что Google сокращает ваш IP-адрес на территории государств-членов Европейского союза или других стран-участниц Соглашения о Европейском экономическом пространстве перед его передачей в США.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">6. Плагины и инструменты</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Google Web Fonts</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Для единообразного отображения шрифтов на сайте используются так называемые веб-шрифты от Google. Когда вы заходите на страницу, ваш браузер загружает нужные шрифты в свой кэш для корректного отображения текстов.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Google Maps</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Наш сайт использует картографический сервис Google Maps через API. Для работы функций Google Maps необходимо сохранить ваш IP-адрес. Эта информация, как правило, передаётся на сервер Google в США и там сохраняется.
                </p>
              </div>

              <div className="bg-rose-50 border border-rose-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">Вопросы о защите данных</h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Если у вас возникли вопросы по защите данных, пожалуйста, напишите нам по адресу: alphavita@gmx.de
                </p>
                <p className="text-xs sm:text-sm text-gray-500 mt-3 sm:mt-4">
                  Emmendingen, 20 сентября 2025
                </p>
              </div>
            </motion.div>
          </div>
        </motion.section>
      </main>
      <Footer />
    </div>
  );
}
